@if (labelCols != null) {
    <div [ngClass]="{'form-group row': labelCols > 0}">
        @if (labelCols > 0) {
            <label class="col-form-label" [class]="labelClass" [for]="id">{{ label }}</label>
        }
        <div [class]="inputColsClass">
            <ng-container [ngTemplateOutlet]="select" />
        </div>
    </div>
} @else {
    <div [ngClass]="{'mb-3': label.length > 0}">
        @if (label.length > 0) {
            <label class="form-label" [class]="labelClass" [for]="id">
                {{ label }}
            </label>
            @if (information) {
                <app-popover-icon class="ms-3" [popover]="information" />
            }
        }
        <ng-container [ngTemplateOutlet]="select" />
    </div>
}

<ng-template #select>
    <select
        class="form-select"
        [formControl]="formControl"
        [class.is-invalid]="ngControl.invalid && ngControl.touched"
        [id]="id"
        (blur)="onTouch?.()">
        @for (item of data | keyvalue: order; track item) {
            <option [ngValue]="item.key">
                {{ item.value }}
            </option>
        }
    </select>
    @if (ngControl.control != null) {
        <app-control-messages [control]="ngControl.control" />
    }
</ng-template>
